<template>
  <div>HEADER</div>
</template>

<script lang="ts">
export default defineNuxtComponent({
  name: 'TheHeader',
});
</script>
